<template>
    <div class="writers">
        <div :class="wrapper_class">
            <div v-show="isMobile" class="writer"><span class="bold">{{ title }}: </span></div> 
            <div class="scroll_mobile_spans">
                <div>
                    <div class="scroll_mobile_spans_inner">
                        <span v-show="!isMobile" class="bold">{{ title }}: </span>
                        <span class="link_span" v-for="item in content" :key="item">
                            <router-link :to="'/' + page_path + '/' + item">
                                <span >{{ content.length ? item : 'Неизвестно' }}</span>
                            </router-link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            required: true
        },
        title: {
            type: String,
            required: true
        },
        wrapper_class:{
            type: String,
            required: true
        },
        page_path:{
            type: String,
            required: true
        }
    },
    data(){
        return{
            isMobile: true
        }  
    },
    mounted(){
        this.isMobile = this.isMobileFunc();
        console.log(this.content.length)
    },
    methods:{
        isMobileFunc: function() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                console.log(true);
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped>
.writers{
    margin-top: 10px;
}

.link_span{
    display: inline-block; 
    border: 1px solid #5555555e;
    border-radius: 5px; 
    background: #2a2a2a99;
    color:white; 
    padding: 0 6px;
    margin: 2px 6px 4px 0;
}


@media only screen and (max-width: 768px) {
  .writers{
    margin-top: 0;
  }

  .writer{
    display: inline-block;
    margin-bottom: 4px;
  }


  .overflow-wrapper0{
    white-space: nowrap;
    padding-right: 66px;
  }

  .overflow-wrapper{
    white-space: nowrap;
    padding-right: 66px;
  }

  .overflow-wrapper1{
    white-space: nowrap;
    padding-right: 94px;
  }

  .scroll_mobile_spans{
    display: inline-block;
    width: 100%;
    height: 30px;
    overflow-x: auto;
    transform: translate(4px, 10px);
    
  }

  .scroll_mobile_spans > div{
    position: absolute;
    z-index: 999;
    height: auto;
  }

  .link_span{
    display: inline-block; 
    border: 1px solid #5555555e;
    border-radius: 5px; 
    background: #2a2a2a99;
    color:white; 
    padding: 0 6px;
    margin: 2px 6px 4px 0;
  }

  

  .scroll_mobile_spans_inner span:last-child{
    margin-right: 0;
  }
}
</style>